import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"; // これを追加

// 先ほど .env に書いた秘密の情報を読み込みます
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL:"https://quiz-party-3a8a6-default-rtdb.asia-southeast1.firebasedatabase.app/",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
};

// Firebaseを初期化
const app = initializeApp(firebaseConfig);

// データベース（Firestore）を使えるようにして、外のファイルでも使えるように書き出し
export const db = getDatabase(app); // これを App.js で使う